module.exports = __webpack_public_path__ + "assets/img/scansBlockIcon.8b4e5f4f.svg";